import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOnlineShopGoodsList, onlineShopGoodsFind, deleteOnlineShopGoods, updateOnlineShopGoods } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { getSellerList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

import { saveAs } from 'file-saver';
var path = process.env.VUE_APP_BASE_API;

var _this;

export default {
  name: 'OnlineShopGoodsManage',
  components: {},
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerName: function getSellerName(id) {
      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId == id) {
          return _this.sellerOptions[i].sellerName;
        }
      }

      return '';
    },
    getActivityTypes: function getActivityTypes(activityTypes) {
      var activityTypesArr = activityTypes.split(',');
      var arr = [];

      if (activityTypesArr.includes('1')) {
        arr.push('券');
      }

      if (activityTypesArr.includes('2')) {
        arr.push('积分');
      }

      return arr.length === 0 ? '' : '返' + arr.join('+');
    },
    getShowAreaList: function getShowAreaList(showAreaList) {
      if (!showAreaList) return '';
      var arr = [];
      showAreaList.forEach(function (item) {
        arr.push(item.showAreaName);
      });
      return arr.join('，');
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getOnlineShopGoodsList,
      type: '',
      path: path,
      title: '',
      addVisible: false,
      expandRowKeys: [],
      sellerOptions: [],
      downloadTplUrl: ''
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var sellerOptions, configRes;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log(' created');
              _context.next = 3;
              return getSellerList({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 3:
              sellerOptions = _context.sent;
              _this2.sellerOptions = sellerOptions.data.list;
              _this2.searchInfo.sellerId = _this2.sellerOptions[0].sellerId;
              _context.next = 8;
              return _this2.getTableData();

            case 8:
              _context.next = 10;
              return _this2.filterDictItemLabel(3, 'onlineshopConfig');

            case 10:
              configRes = _context.sent;
              _this2.downloadTplUrl = JSON.parse(configRes).url;

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
      this.expandRowKeys = [];
    },
    onReset: function onReset() {
      this.searchInfo = {
        sellerId: this.sellerOptions[0].sellerId
      };
      this.onSubmit();
    },
    onRowClick: function onRowClick(row, column) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(column.label === '操作')) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (row.hasExpand) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return onlineShopGoodsFind({
                  'goodsDetailNo': row.goodsDetailNo
                });

              case 5:
                res = _context2.sent;

                if (res.code == 0) {
                  row.hasExpand = true;
                  row.relationSpuNoList = res.data.relationSpuNoList;
                }

              case 7:
                if (_this3.expandRowKeys.length > 0 && row.sellerId + '-' + row.ID === _this3.expandRowKeys[0]) {
                  _this3.expandRowKeys = [];
                } else {
                  _this3.expandRowKeys = [row.sellerId + '-' + row.ID];
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getRowKey: function getRowKey(row) {
      return row.sellerId + '-' + row.ID;
    },
    onAdd: function onAdd() {
      this.$router.push({
        name: 'OnlineShopAddGoods',
        query: {},
        params: {
          meta: {
            title: '新增商品'
          },
          gobackParam: {
            isGoback: true,
            activeName: 'GoodsManage'
          },
          action: 'add'
        }
      });
    },
    onUpdate: function onUpdate(row) {
      this.$router.push({
        name: 'OnlineShopAddGoods',
        query: {},
        params: {
          meta: {
            title: '变更商品'
          },
          gobackParam: {
            isGoback: true,
            activeName: 'GoodsManage'
          },
          action: 'update',
          goodsDetailNo: row.goodsDetailNo
        }
      });
    },
    onUpdateStatus: function onUpdateStatus(row, status) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return updateOnlineShopGoods({
                  'goodsDetailNo': row.goodsDetailNo,
                  'isChangeShowStatus': 1,
                  'showStatus': status
                });

              case 2:
                _this4.getTableData();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onDelete: function onDelete(row) {
      var _this5 = this;

      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return deleteOnlineShopGoods({
                  'goodsDetailNoList': [row.goodsDetailNo]
                });

              case 2:
                _this5.getTableData();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))).catch(function (err) {});
    },
    onDownload: function onDownload() {
      saveAs(this.downloadTplUrl);
    },
    handleCommand: function handleCommand(command) {
      if (command.action === 'updateStatus') {
        this.onUpdateStatus(command.row, command.updateStatus);
      }

      if (command.action === 'delete') {
        this.onDelete(command.row);
      }
    },
    onUplodResponse: function onUplodResponse(response, file, fileList) {
      this.getTableData();

      if (response.code != 0) {
        this.$message({
          type: 'error',
          message: response.msg
        });
        return;
      }

      this.$message({
        type: 'success',
        message: '上传成功'
      });
    }
  }
};